interface ChartLoadingStateProps {
  message?: string
}

export function ChartLoadingState({
  message = 'Loading chart data...',
}: ChartLoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center w-full gap-3 my-8">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      <p className="text-sm text-muted-foreground text-center">{message}</p>
    </div>
  )
}
